<template>
    <div class="mb-32">
        <radio-button
            v-model="filter.unrated"
            value="-1"
        >
            {{ $t('applications.show_all') }}
        </radio-button>
        <radio-button
            v-model="filter.unrated"
            value="0"
        >
            {{ $t('applications.hide_unrated') }}
        </radio-button>
        <radio-button
            v-model="filter.unrated"
            value="1"
        >
            {{ $t('applications.show_unrated') }}
        </radio-button>

        <toggle v-model="filter.score" class="mt-32">
        	{{ $t('applications.filters.use_score') }}
        </toggle>
        <div v-if="filter.score" class="space-y-12 mt-12">
		    <input-component
                v-model="filter.score_min"
                type="number"
                min="0"
                :max="filter.score_max"
                :input-label="$t('general.from')"
            />
		    <input-component
                v-model="filter.score_max"
                type="number"
                :min="filter.score_min"
                max="100"
                :input-label="$t('general.to')"
            />
		</div>
    </div>
</template>

<script>
import Input from '../forms/Input.vue';
import RadioButton from '../forms/RadioButton.vue';
import Toggle from '../forms/Toggle.vue';

export default {
    components: {
        'input-component': Input,
        'radio-button': RadioButton,
        'toggle': Toggle
    },
    props: {
        filter: Object
    }
}
</script>
